/**
 * Acquisition attribution API.
 *
 * Reports the first-touch campaign params captured at landing (see
 * `@/lib/attribution`) to the web-backend once, after the first successful
 * auth. The backend is first-non-empty-touch-wins, so repeat or empty reports
 * never clobber real attribution.
 */

import { post } from './client';
import type { StoredAttribution } from '@/lib/attribution';

export interface AcquisitionPayload {
  params: Record<string, string>;
  referrer?: string;
  landing_page?: string;
  landed_at?: string;
}

// async is load-bearing: it converts any synchronous serialization throw into
// a rejection the caller's .catch() owns, instead of an uncaught effect error
// that unmounts the React tree (no ErrorBoundary is mounted app-wide).
export async function reportAcquisition(stored: StoredAttribution): Promise<{ status: string }> {
  const payload: AcquisitionPayload = { params: stored.params };
  if (stored.referrer) payload.referrer = stored.referrer;
  if (stored.landingPage) payload.landing_page = stored.landingPage;
  if (stored.landedAt) payload.landed_at = new Date(stored.landedAt).toISOString();
  return post<{ status: string }>('/v1/acquisition', payload);
}
